export const outboxQueryKeys = {
	outbox: {
		all: ["outbox"] as const,
		detail: (id: string) => ["outbox", id] as const,
		stats: ["outbox", "stats"] as const,
	},
} as const;
